const SellingCategories=[
{
    "heading":"Books, Movie & Games",
     "products":["Books","Movies","Musical Instruments","Music","Video Games"]
},
{
    "heading":"Home, Garden & Tools, Furniture",
    "products":["Home","Large Appliances","Pet supplies","Kitchen","Furniture"]
},
{
    "heading":"Electronics & Computers",
    "products":["Computer Electronics","Mobile phones","Personal computers","Office products","Software"]
},
{
    "heading":"Books, Movie & Games",
     "products":["Books","Movies","Musical Instruments","Music","Video Games"]
},
{
    "heading":"Home, Garden & Tools, Furniture",
    "products":["Home","Large Appliances","Pet supplies","Kitchen","Furniture"]
},
{
    "heading":"Electronics & Computers",
    "products":["Computer Electronics","Mobile phones","Personal computers","Office products","Software"]
},
{
    "heading":"Automotive & Industrial supply",
    "products":["Automotive","Industrial supply"]
},
{
    "heading":"Other",
    "products":["My category is not here"]
}
];

export default SellingCategories;